module.exports = __webpack_public_path__ + "media/images/emblems/Arch-coat_of_arms-592320f54e76f53ac44a09949de87200.svg";